import OrganizationsPage from '@/pages/Organizations';
import { createLazyFileRoute } from '@tanstack/react-router';

export const Route = createLazyFileRoute('/organizations/')({
  component: OrganizationsPage,
});
